import { render, staticRenderFns } from "./ResourceSlideInPanel.vue?vue&type=template&id=bbf16244&lang=pug&"
import script from "./ResourceSlideInPanel.vue?vue&type=script&lang=js&"
export * from "./ResourceSlideInPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports